import { Controller } from "@hotwired/stimulus";
import Swal from "sweetalert2";
import $ from "jquery";

window.Swal = Swal;

export default class extends Controller {
  connect() {
    const Toast = Swal.mixin({
      animation: import.meta.env.RAILS_ENV === "test" ? false : true,
      customClass: {
        popup: "colored-toast"
      },
      iconColor: "white",
      position: "top",
      showConfirmButton: false,
      showCloseButton: true,
      timer: import.meta.env.RAILS_ENV === "test" ? null : 16000,
      timerProgressBar: true,
      toast: true,
      width: "400px"
    });

    const flashElement = this.element;
    const flashMessages = flashElement.querySelectorAll("[data-flash-type]");

    flashMessages.forEach((message) => {
      const type = message.dataset.flashType;
      const content = message.dataset.flashMessage;
      const duration = message.dataset.flashDuration ? parseInt(message.dataset.flashDuration) : null;

      const toastOptions = {
        icon: type === "error" ? "error" : type === "warning" ? "warning" : type === "info" ? "info" : "success",
        title: content
      };

      // Override the default timer if a custom duration is provided
      if (duration !== null) {
        toastOptions.timer = duration;
      }

      Toast.fire(toastOptions);

      if (type === "error") {
        setTimeout(function () {
          if ($(".is-invalid").length > 0) {
            $(".is-invalid")[0].scrollIntoView();
          }
        }, 500);
      }
    });

    // Clear the flash messages after displaying
    flashElement.innerHTML = "";
  }
}
